'use strict';

angular.module('app')
    .controller('PrintHistoryController', ['$scope', '$stateParams', 'Recipe', 'Print', '$q', function ($scope, $stateParams, Recipe, Print, $q) {
        $scope.printHistory = [];
        
        var promises = [
            Recipe.get({id: $stateParams.id}).$promise,
            Print.get({id: $stateParams.id}).$promise
        ];

        $q.all(promises).then(function (results) {
            $scope.recipe = results[0];
            $scope.printHistory = results[1];
        });
    }]);